module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"addReviewLink":"Add review link","setupPopoverTitle":"Boost your business with Google Reviews","setupPopoverMessage":"From being found online to earning trust, reviews are a proven source of new business.","setupReviews":"Connect to Google Reviews"}}')
  delete Component.options._Ctor
}
